import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface StickyCTAUtilityProps {
  isVisible: boolean;
  analyticsId: string;
}

export const StickyCTAUtility = ({ isVisible, analyticsId }: StickyCTAUtilityProps) => {
  return (
    <Row
      aria-hidden={!isVisible}
      className={cn(
        // Centered fixed bar (atoms bans margin utils, so center via left-1/2 + -translate-x-1/2).
        'fixed left-1/2 top-[2%] z-[9999] w-75 -translate-x-1/2 items-center justify-between p-1.5 md:w-90',
        'rounded-[20px] bg-od-bg-tertiary shadow-[0_8px_20px_rgba(0,0,0,0.04)] backdrop-blur-[20px]',
        // Reveal/hide: slide + scale + fade over 0.7s (replaces the bricks keyframe animation).
        'transition duration-700',
        isVisible
          ? 'translate-y-0 scale-100 opacity-100'
          : 'pointer-events-none -translate-y-full scale-90 opacity-0',
      )}
    >
      <Text as="p" className="px-4 text-label-xl md:px-5">
        Still selling?
      </Text>
      <Button
        onClick={() => window.location.assign('/address-entry')}
        aria-label="sticky CTA utility"
        analyticsName={`cosmos-landing-page-sticky-cta-${analyticsId}`}
        variant="primary"
        size="sm"
        className={cn(
          'max-w-35 lg:min-h-13 xl:max-w-40',
          // Force the primary background over cosmos's global `button { background: transparent }` reset.
          '!bg-od-bg-accent-brand not-disabled:hover:!bg-od-bg-hover-accent-brand not-disabled:active:!bg-od-bg-pressed-accent-brand',
        )}
      >
        Get cash offer
      </Button>
    </Row>
  );
};
